import { PermissionService } from '@services/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Actions } from '../actions'

export const findAllPermissions = createAsyncThunk(
  Actions.PERMISSION_FIND_ALL,
  async (_, { rejectWithValue }) => {
    try {
      const permissions = await PermissionService.findAllPermissions()
      return permissions
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)
